export default __webpack_public_path__ + "static/media/clan-bg.cea92818.png";